import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HttpService } from '@core/services';
import { ProjectManagementHttpService } from '@core/services/http';
import { ProjectManagementActions } from '@store/actions';
import { ProjectManagementSelectors } from '@store/selectors';

type Tab = 'summary' | 'financial';

export const usePMTabPrefetch = (currentTab: Tab, projectBundleID: string) => {
  const dispatch = useDispatch();

  const financialLoaded = useSelector(
    ProjectManagementSelectors.isTabDataLoaded('financial'),
  );

  useEffect(() => {
    const prefetchDelay = 1000;

    const prefetchMap: Partial<Record<Tab, Tab[]>> = {
      summary: ['financial'],
    };

    const loadingStates = {
      financial: financialLoaded,
    };

    const timer = setTimeout(() => {
      prefetchMap[currentTab]?.forEach(async (tabName: Tab) => {
        if (!loadingStates[tabName as keyof typeof loadingStates]) {
          dispatch(
            ProjectManagementActions.setTabLoading.done({
              tabName,
              isLoading: true,
            }),
          );

          switch (tabName) {
            case 'financial':
              await HttpService.getHttpRequests(
                ProjectManagementHttpService,
              ).getProjectManagementFinancial(projectBundleID, {
                silent: true,
              });

              break;

            default:
              break;
          }
        }
      });
    }, prefetchDelay);

    return () => clearTimeout(timer);
  }, [currentTab, financialLoaded]);
};
